const zh = {
    '/': {
        title: '{brand} & 体育博彩 | 加密货币即时提现',
        description: '{brand}与体育博彩共用一个钱包。老虎机、真人娱乐场和公平可验证的原创游戏，以及体育投注，加密货币即时提现。',
        keywords: '加密货币赌场, 比特币赌场, 加密体育博彩, 在线老虎机, 即时提现, 公平可验证'
    },
    '/casino': {
        title: '{brand} 在线娱乐场 | 老虎机、21点 & 真人荷官',
        description: '在{brand}玩老虎机、21点、轮盘 & 真人荷官。数百种游戏，快速加密货币存款 & 24/7即时提款。',
        keywords: '加密货币赌场, 比特币赌场, 在线赌场, 加密老虎机, 真人娱乐场, 21点, 轮盘'
    },
    '/sports': {
        title: '{brand} 在线体育博彩 | 加密货币体育投注 & 赔率',
        description: '在{brand}进行体育博彩。足球、篮球等具有竞争力的赔率。现场投注、安全的加密货币下注 & 快速支付。',
        keywords: '加密体育博彩, 比特币体育投注, 滚球投注, 足球赔率, 电竞投注'
    },
    '/livecasino': {
        title: '{brand} 真人娱乐场 | 21点、轮盘 & 真人荷官',
        description: '在{brand}玩21点、轮盘 & 真人娱乐场游戏。真实荷官，高清直播 & 24/7丰富真人桌台。',
        keywords: '真人娱乐场, 真人荷官, 真人21点, 真人轮盘, 真人百家乐, game show'
    },
    '/slots': {
        title: '{brand} 在线老虎机 | 海量娱乐场老虎机',
        description: '在{brand}旋转海量老虎机合集。经典水果机、视频老虎机 & 累积奖金，均可使用加密货币游玩。',
        keywords: '加密老虎机, 比特币老虎机, 在线老虎机, 视频老虎机, megaways 老虎机, 购买免费游戏'
    },
    '/vip': {
        title: '{brand} VIP计划 | 专属奖励 & 福利',
        description: '{brand}的VIP计划：专属奖励、个性化奖金和优先支持。为忠实玩家量身定制的特权。',
        keywords: '赌场VIP计划, 返水, 忠诚度奖励, 高额投注赌场, VIP等级'
    },
    '/welcome-offer': {
        title: '{brand} 欢迎优惠 | 加密货币娱乐场',
        description: '了解{brand}的欢迎优惠。使用加密货币开始游戏，享受新玩家专属福利。',
        keywords: '赌场欢迎奖金, 加密赌场奖金, 首存奖金, 新玩家优惠'
    },
    '/referral': {
        title: '{brand} 推荐计划 | 赚取奖励',
        description: '邀请朋友加入{brand}，当他们注册并满足条件时即可赚取奖励。分享您的推荐链接，开始赚取。',
        keywords: '赌场推荐计划, 邀请好友奖励, 联盟奖励'
    },
    '/promotion-page': {
        title: '{brand} 促销活动 | 奖金 & 特别优惠',
        description: '浏览{brand}所有活跃促销。加密货币玩家专享的奖金、免费旋转和特别优惠。',
        keywords: '赌场优惠, 加密赌场奖金, 每周竞赛, 赌场锦标赛'
    },
    '/hotslots': {
        title: '{brand} 热门老虎机 | 热门娱乐场老虎机',
        description: '在{brand}玩最受欢迎的老虎机。支持加密货币的热门老虎机一应俱全。'
    },
    '/newgames': {
        title: '{brand} 新游戏 | 最新娱乐场游戏',
        description: '探索{brand}最新的娱乐场游戏。新老虎机、真人游戏和桌游不断上线。'
    },
    '/populargames': {
        title: '{brand} 热门游戏 | 最受欢迎娱乐场游戏',
        description: '{brand}最受欢迎的娱乐场游戏。从老虎机到真人游戏，全部支持加密货币。'
    },
    '/gameshows': {
        title: '{brand} 游戏节目 | 真人游戏节目娱乐场',
        description: '在{brand}享受真人游戏节目。真实主持人现场互动，独特游戏玩法，丰厚奖励。'
    },
    '/table_games': {
        title: '{brand} 桌游 | 21点、轮盘 & 百家乐',
        description: '在{brand}玩21点、轮盘、百家乐等桌游。全部支持加密货币游玩。'
    },
    '/hotlive': {
        title: '{brand} 热门真人娱乐场 | 热门真人游戏',
        description: '{brand}最受欢迎的真人娱乐场游戏。与真实荷官实时互动游戏。'
    },
    '/featurebuyin': {
        title: '{brand} 特购功能老虎机 | 直购奖励轮老虎机',
        description: '在{brand}玩支持购买特购功能的老虎机。直接进入奖励轮，无需等待触发。'
    },
    '/originals': {
        title: '{brand} 原创娱乐场游戏 | 独家原创游戏',
        description: '在{brand}畅玩独家原创游戏。这些独一无二的自研游戏，在其他任何地方都找不到，为您带来无与伦比的娱乐场体验。'
    },
    '/providers': {
        title: '{brand} 游戏提供商 | 合作工作室 & 软件',
        description: '探索{brand}的所有游戏提供商。我们与顶级工作室合作，为您提供多样化的高品质加密货币娱乐场游戏库。'
    },
    '/about-us': {
        title: '关于我们 | 了解更多关于 {brand}',
        description: '了解{brand} - 领先的加密货币娱乐场 & 体育博彩平台。致力于提供安全、公平 & 刺激的博彩体验及即时加密货币提款服务。'
    },
    '/affiliate': {
        title: '联盟计划 | 与 {brand} 共赚加密货币',
        description: '成为{brand}的合作伙伴，推广我们的加密货币娱乐场并赚取佣金。有竞争力的佣金比例、实时追踪及专属联盟支持。'
    },
    '/faq': {
        title: '{brand} 常见问题 | FAQ',
        description: '查找关于{brand}常见问题的解答。浏览我们的FAQ，获取有关账户、支付、奖金 & 娱乐场游戏的帮助。'
    },
    '/aml-policy': {
        title: 'AML政策 | {brand}反洗钱声明',
        description: '{brand}的AML政策确保安全可信的环境。了解我们防止平台上非法活动的相关措施。'
    },
    '/bonus-terms': {
        title: '奖金条款与条件 | {brand}优惠活动',
        description: '阅读{brand}娱乐场奖金 & 优惠活动的规则。了解如何领取、使用 & 提取奖金奖励。'
    },
    '/complaints-and-arbitration': {
        title: '投诉与仲裁 | {brand}玩家支持',
        description: '查找{brand}的投诉 & 争议解决流程。我们确保公平对待，迅速透明地解决玩家问题。'
    },
    '/fairness': {
        title: '可验证公平游戏 | {brand}公平性保障',
        description: '{brand}采用可验证公平技术，确保每个游戏结果均可验证、透明 & 完全随机。'
    },
    '/kyc-policy': {
        title: 'KYC政策 | {brand}客户身份验证',
        description: '{brand}的KYC政策概述了我们的身份验证流程。了解我们如何保护玩家并维护安全的游戏环境。'
    },
    '/payment-policy': {
        title: '{brand} 支付政策 | 加密货币存取款',
        description: '{brand}接受加密货币存款 & 提款。阅读我们的支付政策，了解交易限额、支持的币种 & 处理时间。'
    },
    '/privacy-policy': {
        title: '隐私政策 | {brand}数据保护',
        description: '{brand}的隐私政策。了解我们如何在加密货币娱乐场平台上收集、使用 & 保护您的个人数据。'
    },
    '/responsible-gaming': {
        title: '负责任博彩 | 在 {brand} 安全游玩',
        description: '{brand}致力于负责任博彩。使用工具 & 资源管理您的游戏习惯，享受安全健康的游戏体验。'
    },
    '/terms-of-service': {
        title: '服务条款 | {brand}',
        description: '查阅规范您使用{brand}的条款与条件。了解作为玩家的权利和责任。'
    },
    '/terms-sports': {
        title: '体育博彩条款与条件 | {brand}',
        description: '{brand}的体育博彩条款与条件。有关下注规则、奖金支付 & 平台体育博彩使用的相关规定。'
    },
    '/special-bets': {
        title: '{brand} 特别投注 | 加密货币体育博彩',
        description: '在 {brand} 进行特别投注。涵盖体育、电竞 & 单场活动盘口，加密货币即时存款、快速派彩。'
    },
    '/transparency': {
        title: '{brand} 透明度 | 可证明公平的加密货币娱乐场',
        description: '了解 {brand} 如何公开运营：可证明公平的游戏验证、从实时目录读取并公布的回报率 & 链上派彩。'
    },
    '/faq/about': {
        title: '关于 {brand} | 常见问题',
        description: '关于 {brand}：牌照、加密货币娱乐场的运作方式 & 平台如何做到公平。常见问题解答。'
    },
    '/faq/account': {
        title: '{brand} 账户 | 常见问题',
        description: '管理您的 {brand} 账户：注册、登录、验证 & 个人资料设置。账户相关常见问题解答。'
    },
    '/faq/bonuses': {
        title: '{brand} 奖金 | 常见问题',
        description: '{brand} 奖金说明：迎新优惠、促销码、流水要求 & 回馈。奖金相关常见问题解答。'
    },
    '/faq/deposits': {
        title: '{brand} 存款 | 常见问题',
        description: '如何在 {brand} 存入加密货币：支持的币种、网络、最低金额 & 确认时间。存款相关常见问题解答。'
    },
    '/faq/games-sports': {
        title: '{brand} 游戏 & 体育 | 常见问题',
        description: '{brand} 的娱乐场游戏 & 体育博彩：供应商、可证明公平、赔率 & 滚球投注。常见问题解答。'
    },
    '/faq/responsible-gambling': {
        title: '{brand} 负责任博彩 | 常见问题',
        description: '{brand} 的负责任博彩：存款限额、自我排除、冷静期 & 帮助您安全游戏的支持工具。'
    },
    '/faq/security': {
        title: '{brand} 安全 | 常见问题',
        description: '{brand} 的安全措施：账户保护、双重验证、公平性 & 数据隐私。安全相关常见问题解答。'
    },
    '/faq/support-disputes': {
        title: '{brand} 客服 & 争议 | 常见问题',
        description: '在 {brand} 获取帮助：在线客服、响应时间 & 争议如何解决。常见问题解答。'
    },
    '/faq/withdrawals': {
        title: '{brand} 提款 | 常见问题',
        description: '如何从 {brand} 提取加密货币：到账时间、最低金额、手续费 & 限额。提款相关常见问题解答。'
    }
};
export default zh;
